import { Entity, schema } from "@rest-hooks/rest";
import AuthdEndpoint from "./AuthdEndpoint";
import { BASE_URL } from "./constants";

export class EnvironmentEntity extends Entity {
  id: string = "";

  pk(
    parent?: any,
    key?: string | undefined,
    args?: readonly any[] | undefined
  ): string | undefined {
    return this.id;
  }
}

export class MeetingType extends Entity {
  id: string = "";
  title?: string;
  shortDescription?: string;
  description?: string;
  calendarEventTitle?: string;
  notificationTitle?: string;
  notificationDescription?: string;
  EnvironmentVisibility?: EnvironmentEntity[];

  pk(
    parent?: any,
    key?: string | undefined,
    args?: readonly any[] | undefined
  ): string | undefined {
    return this.id;
  }
}

const getMeetingTypesEndpoint = new AuthdEndpoint({
  urlPrefix: BASE_URL,
  path: "/admin/meeting-types",
  schema: new schema.Collection([MeetingType]),
  process: async (result) => {
    return result as MeetingType[];
  },
});

export const MeetingTypesResource = {
  getList: getMeetingTypesEndpoint,
};
